module.exports = __webpack_public_path__ + "static/share-of-amazon-third-party-sellers-22cc1240059289c6e22fec801ebf1c10.png";